import {Component, Input, OnInit, Output, TemplateRef, EventEmitter} from '@angular/core';
import {ITdoTreeItem} from './models/i-tdo-tree-item';
import {CdkDragDrop, CdkDragEnter} from '@angular/cdk/drag-drop';
import {IoTreeNodeModel} from '../../../modules/imaging/models/io-tree-node.model';

export class TdoTreeDropItem {
  data: CdkDragDrop<IoTreeNodeModel>;
  treeItem: IoTreeNodeModel;
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'tdo-tree',
  templateUrl: './tdo-tree.component.html',
  styleUrls: ['./tdo-tree.component.scss']
})
export class TdoTreeComponent implements OnInit {
  @Input() dataSource: IoTreeNodeModel[];
  @Input() expandableNodeClosedImagePath: string;
  @Input() expandableNodeOpenImagePath: string;
  @Input() nodeImagePath: string;

  @Input() template: TemplateRef<any>;
  @Output() itemSelected = new EventEmitter<ITdoTreeItem>();
  @Output() itemDrop = new EventEmitter<TdoTreeDropItem>();

  isFileExplorerEntered = false;

  constructor() { }

  ngOnInit(): void {
  }

  onItemSelected(item: ITdoTreeItem): void {
    this.itemSelected.emit(item);
  }

  onFileExplorerEntered(event: CdkDragEnter<ITdoTreeItem>): void {
    for (const model of this.dataSource) {
      model.isExpanded = true;
    }
  }

  onItemDropped(event: CdkDragDrop<IoTreeNodeModel>, treeNodeItem: IoTreeNodeModel = null) {
    const it = new TdoTreeDropItem();
    it.data = event;
    it.treeItem = treeNodeItem;
    this.itemDrop.emit(it);
  }
}
